const WebFont = require('webfontloader');

site.google_font_families.forEach((v, i, a) => {
    a[i] = v + ':400,bold,italic';
});

let fontOptions = {};
switch (true) {
    case site.typekit_id.length > 0:
        fontOptions.typekit = {
            id: site.typekit_id
        };
        break;
    case site.google_font_families.length > 0:
        fontOptions.google = {
            families: site.google_font_families
        };
        break;
    default:
        fontOptions.custom = {
            families: ['open_sans'],
            urls: [site.theme_uri + '/assets/css/fonts.min.css']
        };
        break;
}

console.log(fontOptions, site.google_font_families.length, site.typekit_id);
WebFont.load(fontOptions);
